import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.readMoreActivated)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.truncateText(_ctx.longText as string)), 1))
      : _createCommentVNode("", true),
    (!_ctx.readMoreActivated)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.activateReadMore && _ctx.activateReadMore(...args))),
          href: "#"
        }, "More..."))
      : _createCommentVNode("", true),
    (_ctx.readMoreActivated)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          innerHTML: _ctx.longText
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}